import type { AttemptQuestionDto } from "@mmm/contracts";
import { ListRow } from "./ListRow.js";
import { QUESTION_TYPE_LABEL_KEYS } from "../../constants.js";
import { Badge, Card, useT } from "@mmm/ui";
export function AnswerReviewCard({ question }: { question: AttemptQuestionDto }) {
  const t = useT();
  const response = question.response;
  const selected = new Set(question.selectedAnswers.map((answer) => answer.answerOptionId));
  const options = question.answerOptions.slice().sort((a, b) => a.sortOrder - b.sortOrder);
  const learner = question.type === "freeText" ? response?.answerText : options.filter((option) => selected.has(option.id)).map((option) => option.text).join("; ");
  const correct = question.type === "freeText" ? question.correctAnswer : options.filter((option) => option.isCorrect).map((option) => option.text).join("; ");
  const feedback = response?.markingFeedback;
  return <Card padding="lg" className="mmm-answer-review-card">
    <div className="mmm-answer-review-head">
      <div><p className="mmm-review-type">{t(QUESTION_TYPE_LABEL_KEYS[question.type])}</p><h2>{t("tests.numberedPrompt", { number: question.questionNumber, prompt: question.prompt })}</h2></div>
      <Badge tone={response?.isCorrect ? "success" : "neutral"} className="mmm-review-score">{t("tests.pointsRatio", { awarded: response?.pointsAwarded ?? 0, max: response?.maxPoints ?? 0 })}</Badge>
    </div>
    <div className="mmm-review-answers">
      <div className="mmm-review-answer mmm-review-answer--yours"><h3>{t("tests.learnersAnswer")}</h3><p className="mmm-review-answer-text">{learner?.trim() || t("tests.unanswered")}</p></div>
      <div className="mmm-review-answer mmm-review-answer--model"><h3>{t("tests.modelAnswer")}</h3><p className="mmm-review-answer-text">{correct}</p></div>
    </div>
    <div className="mmm-review-explanation"><h3>{t("tests.explanation")}</h3><p>{feedback?.rationale || question.explanation}</p></div>
    {feedback && feedback.rubricFindings.length > 0 && <div className="mmm-review-rubric">
      <h3>{t("tests.markingBreakdown")}</h3>
      {feedback.rubricFindings.map((finding) => {
        const item = question.rubricItems.find((rubric) => rubric.id === finding.rubricItemId);
        return <ListRow key={finding.rubricItemId} className="mmm-review-rubric-row" title={item?.text} meta={finding.reason} trailing={<span className="mmm-review-score">{t("tests.pointsRatio", { awarded: finding.pointsAwarded, max: item?.points ?? 0 })}</span>} />;
      })}
    </div>}
  </Card>;
}
